import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SafesimulationsClass } from '../models/safesimulations-class';
import { GlobalService } from './global.service';
import { SvMessageService } from './sv-message.service';
import { UsersService } from './users.service';
import { LoggedUserClass } from '../models/users-class';
// import { AuthUiService } from './ui/auth-ui.service';
import { UtilityService } from './utility.service';
import { AlertMessageService } from './alert-message.service';

@Injectable({
  providedIn: 'root',
})
export class ValidateNifService {
  public DadosInquerito: NgForm | null = null;
  public DadosFinalizarCompra: NgForm | null = null;

  constructor(
    public globalService: GlobalService,
    private usersService: UsersService,
    // private authUi: AuthUiService,
    private alerts: AlertMessageService,
    private utilityService: UtilityService,
    private svMessage: SvMessageService,
  ) {}

  validaNIFExists(onRecover?: () => void) {
    return new Promise<boolean>(resolve => {
      if (!this.globalService.safesimulationsClass.NIF) {
        return false;
      }

      let userClass: LoggedUserClass;
      this.usersService.GetUserNIFExists(this.globalService.safesimulationsClass.NIF).subscribe({
        next: dados => (userClass = dados[0]),
        error: error => {
          this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
          console.log(error);
          this.globalService.safesimulationsClass.DescErro = 'ABORTED';
          resolve(true);
        },
        complete: () => {
          if (userClass) {
            if (userClass.DateEnd) {
              this.svMessage.fire('Utilizador Inativo', 'Por favor, contacte o administrador do site.', 'question');
              this.globalService.safesimulationsClass.DescErro = 'ABORTED';
              resolve(true);
              return;
            } else {
              this.svMessage
                .fire({
                  type: 'warning',
                  title: 'O nº de contribuinte já se encontra registado na nossa base de dados.',
                  text: 'Deseja recuperar a password ou iniciar sessão?',
                  showCancelButton: true,
                  cancelButtonText: 'Não',
                  confirmButtonText: 'Sim',
                  reverseButtons: true,
                })
                .then(async result => {
                  if (result.isConfirmed) {
                    if (onRecover) {
                      onRecover();
                    }

                    if (!this.globalService.safesimulationsClass) {
                      this.globalService.safesimulationsClass = new SafesimulationsClass();
                    }

                    await this.CustomerDatasafesimulationsClass();
                  }

                  // Resolve true in both yes/no cases because the NIF DOES exist,
                  // so the purchase flow must be interrupted!
                  this.globalService.safesimulationsClass.DescErro = 'ABORTED';
                  resolve(true);
                });
            }
          } else {
            this.globalService.SelectedTabauthenticate++;
            resolve(false);
          }
        },
      });
    });
  }

  /**
   * Verifica apenas se o NIF já existe no sistema, sem mostrar popups.
   * Usado para fluxo de autenticação inline.
   */
  checkNifExistsOnly(nif: string): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      if (!nif) {
        resolve(false);
        return;
      }

      this.usersService.GetUserNIFExists(nif).subscribe({
        next: dados => {
          const user = dados?.[0];
          // Retorna true se utilizador existe e está ativo (não tem DateEnd)
          resolve(!!user && !user.DateEnd);
        },
        error: error => {
          console.error('Erro ao verificar NIF:', error);
          resolve(false);
        },
      });
    });
  }

  isNIFEmpresa(nif: string): boolean {
    return this.utilityService.isNIFEmpresa(nif);
  }

  validateNIF(nif: string, AdminValidate: boolean): boolean {
    return this.utilityService.validateNIF(nif, AdminValidate);
  }

  CustomerDatasafesimulationsClass(): Promise<SafesimulationsClass> {
    return new Promise<SafesimulationsClass>(resolve => {
      this.globalService.showProgress = true;
      this.globalService.IsWait = true;

      if (!this.globalService.safesimulationsClass) {
        this.globalService.safesimulationsClass = new SafesimulationsClass();
      }

      const customer = this.globalService.loggedUserClass?.customerClass;
      const safesimulationsClass = this.globalService.safesimulationsClass;

      // Atribuições seguras usando cadeia opcional e coalescência nula
      safesimulationsClass.idCustomer = customer?.idCustomer ?? null;
      safesimulationsClass.Name = customer?.Name ?? '';
      safesimulationsClass.CustomerName = customer?.Name ?? '';
      safesimulationsClass.idCommonNIFType = customer?.idCommonNIFType ?? null;
      safesimulationsClass.idCommercial = customer?.idCommercial ?? null;
      safesimulationsClass.AddressDetail = customer?.AddressDetail ?? '';
      safesimulationsClass.PostalCode = customer?.PostalCode ?? '';
      safesimulationsClass.PostalCodeRegion =
        customer?.PostalCode && customer?.Region ? `${customer.PostalCode} ${customer.Region}` : '';
      safesimulationsClass.Region = customer?.Region ?? '';
      safesimulationsClass.DtNasc1PSeg = customer?.Birthdate ? new Date(customer.Birthdate) : null;
      safesimulationsClass.Name1 = customer?.Name ?? '';
      safesimulationsClass.DtNasc2PSeg = null;
      safesimulationsClass.Name2 = '';
      safesimulationsClass.NIB = customer?.NIB ? customer.NIB.replace('PT50', '').trim() : '';
      safesimulationsClass.NIF = customer?.NIF ?? '';
      safesimulationsClass.Email = customer?.Email ?? '';
      safesimulationsClass.CCNumber = customer?.CCNumber ?? '';
      safesimulationsClass.CCDateValidate = customer?.CCDateValidate ? new Date(customer.CCDateValidate) : null;
      safesimulationsClass.Birthdate = customer?.Birthdate ? new Date(customer.Birthdate) : null;
      safesimulationsClass.idSexTypes = customer?.idSexTypes ?? null;

      // Atualiza 'Sexo' com base em 'idSexTypes'
      safesimulationsClass.Sexo = safesimulationsClass.idSexTypes
        ? (this.globalService.sexTypesClass?.find(r => r.idSexTypes === safesimulationsClass.idSexTypes)?.Description ??
          '')
        : '';

      // Outras atribuições diretas usando a cadeia opcional e coalescência nula
      safesimulationsClass.Contact = customer?.Contact ?? '';
      safesimulationsClass.idMaritalStatus = customer?.idMaritalStatus ?? null;
      safesimulationsClass.Country = customer?.Country ?? '';
      safesimulationsClass.Profession = customer?.Profession ?? '';
      safesimulationsClass.CAE = customer?.CAE ?? '';
      safesimulationsClass.PlaceOfBirth = customer?.PlaceOfBirth ?? '';
      safesimulationsClass.Nationality = customer?.Nationality ?? '';
      safesimulationsClass.Drivinglicense = customer?.Drivinglicense ?? '';
      safesimulationsClass.DrivinglicenseDate = customer?.DrivinglicenseDate
        ? new Date(customer.DrivinglicenseDate)
        : null;
      safesimulationsClass.DrivinglicenseExpirationDate = customer?.DrivinglicenseExpirationDate
        ? new Date(customer.DrivinglicenseExpirationDate)
        : null;
      safesimulationsClass.AutorizacaoDebitoNome = customer?.Name ?? '';
      safesimulationsClass.AutorizacaoDebitoMorada = customer?.AddressDetail ?? '';
      safesimulationsClass.AutorizacaoDebitoCodigoPostal = customer?.PostalCode ?? '';
      safesimulationsClass.AutorizacaoDebitoCodigoRegion = customer?.Region ?? '';
      safesimulationsClass.AutorizacaoDebitoPais = customer?.Country ?? '';
      safesimulationsClass.AutorizacaoDebitoIBAN = customer?.NIB ? customer.NIB.replace('PT50', '').trim() : '';
      safesimulationsClass.BeneficiariosTomadorSeguroNome = customer?.Name ?? '';
      safesimulationsClass.AutoVehiclePlate = '';
      safesimulationsClass.AutoVehiclePlateDate = null;
      safesimulationsClass.idCommonAutoVehicleType = null;
      safesimulationsClass.idCommonAutoVehicleUsage = null;
      safesimulationsClass.idCommonAutoFuel = null;
      safesimulationsClass.idCommonAutoBrand = null;
      safesimulationsClass.idCommonAutoBrandModel = null;
      safesimulationsClass.idCommonAutoBrandModelVersion = null;
      safesimulationsClass.AutoVehicleCV = null;
      safesimulationsClass.AutoVehicleSeats = null;
      safesimulationsClass.AutoVehicleWeight = null;

      safesimulationsClass.AutoNewVehicle = 0;

      if (this.globalService.loggedUserClass?.NIF) {
        if (
          this.globalService.loggedUserClass.NIF.substring(0, 1) === '7' ||
          this.globalService.loggedUserClass.NIF.substring(0, 1) === '5'
        ) {
          safesimulationsClass.idCommonEntityType =
            this.globalService.commonEntityTypeClass?.find(d => d.LibertyCode === 'E')?.idCommonEntityType ?? 2;
          safesimulationsClass.AutoHolderType = 'E';
        } else {
          safesimulationsClass.idCommonEntityType =
            this.globalService.commonEntityTypeClass?.find(d => d.LibertyCode === 'P')?.idCommonEntityType ?? 1;
          safesimulationsClass.AutoHolderType = 'P';
        }
      } else {
        safesimulationsClass.idCommonEntityType =
          this.globalService.commonEntityTypeClass?.find(d => d.LibertyCode === 'P')?.idCommonEntityType ?? 1;
        safesimulationsClass.AutoHolderType = 'P';
      }

      //   if (this.globalService.loggedUserClass.customerClass.customerFavoriteProposalsClass) {
      //     safesimulationsClass.productsProposalsClass?.forEach(element => {
      //       element.Favorite = !!this.globalService.loggedUserClass.customerClass.customerFavoriteProposalsClass.find(
      //         x => x.idProductsTypesProposals === element.idProductsTypesProposals && x.DateEnd === null,
      //       );
      //     });
      //   }

      this.globalService.showProgress = false;
      this.globalService.IsWait = false;

      resolve(safesimulationsClass);
    });
  }
}
